export enum OurPetPolicyLandlordStatus {
  VERIFIED = "VERIFIED",
  NOT_VERIFIED = "NOT_VERIFIED",
  NONE = "NONE"
}

export enum OurPetPolicyStatus {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  NOT_APPROVED = "NOT_APPROVED",
  MOVED_IN = "MOVED_IN",
  MOVED_OUT = "MOVED_OUT",
  ARCHIVED = "ARCHIVED",
  RETRACTED = "RETRACTED",
  NONE = "NONE"
}

export enum OurPetPolicyAnimalType {
  PET = "Pet",
  SA = "SA",
  ESA = "ESA"
}
export interface OurPetPolicyAnimal {
  name?: string;
  birth_date: string;
  weight?: {
    value?: number | null;
    unit?: string | null;
  };
  breed?: string | null;
  species?: string | null;
  primary_color?: string | null;
  gender?: string | null;
  status: OurPetPolicyStatus;
  verification_status: OurPetPolicyLandlordStatus;
  type?: OurPetPolicyAnimalType;
  submitted_date?: number | null;
  converted_to_pet?: boolean | null;
}
